import React from "react";
import PropTypes from "prop-types";
import DefaultTickRenderer from "./TickRenderer";
import Track from "../../models/Track";

function HorizontalGridLabels({
  height: containerHeight,
  pBottom,
  pTop,
  axisConf,
  TickRenderer,
  track,
}) {
  const { ticks, id } = axisConf;
  const height = containerHeight + pTop + pBottom;
  return (
    <div
      style={{ height }}
      className="tw-h-full tw-text-2xs font-roboto tw-relative tw-overflow-hidden"
    >
      {(ticks || []).map((tick, ind) => (
        <div
          key={tick.label || tick[id] || `${new Date().getTime()}-${ind}`}
          style={{ top: `${tick.y}px` }}
          className="tw-opacity-0 tw-px-2"
        >
          <TickRenderer tick={tick} track={track} />
        </div>
      ))}
      {(ticks || []).map((tick, ind) => (
        <div
          key={tick.label || tick[id] || `${new Date().getTime()}-${ind}`}
          style={{
            top: `${tick.y * containerHeight + pTop}px`,
            transform: "translateY(-50%)",
          }}
          className="tw-absolute px-2 tw-text-right tw-inset-x-0"
        >
          <TickRenderer tick={tick} track={track} />
        </div>
      ))}
    </div>
  );
}

HorizontalGridLabels.propTypes = {
  height: PropTypes.number.isRequired,
  pBottom: PropTypes.number.isRequired,
  pTop: PropTypes.number.isRequired,
  TickRenderer: PropTypes.func,
  track: PropTypes.instanceOf(Track).isRequired,
  axisConf: PropTypes.shape({
    centered: PropTypes.bool,
    ticks: PropTypes.arrayOf(PropTypes.shape({})),
    id: PropTypes.string,
  }).isRequired,
};

HorizontalGridLabels.defaultProps = {
  TickRenderer: DefaultTickRenderer,
};

export default HorizontalGridLabels;
